export const WORDPRESS_GRAPHQL_ROOT =
  process.env.NEXT_PUBLIC_WORDPRESS_GRAPHQL_ROOT || 'http://wordpress:80/blog/wp/graphql';

export const WORDPRESS_ASSETS_ROOT =
  process.env.NEXT_PUBLIC_WORDPRESS_ASSETS_ROOT || 'http://wordpress:80/blog/wp/wp-content/uploads';

export const BLOG_ROUTING_BASE = process.env.NEXT_PUBLIC_ROUTING_BASE || '/artykuly';

export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://pl.canalplus.com/blog';
